import { useCallback, useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useAuthImage, useJob } from "../../hooks/useJob";
import { Button } from "../ui/button";
import { OutputsList } from "../OutputsList";
import { SchedulePanel } from "./SchedulePanel";

function Strip({ p }) {
  const src = useAuthImage(`/comic-pages/${p.id}/render?w=400`, p.updated_at);
  return src ? <img src={src} alt={`Panel ${p.number}`} className="w-full block" /> : <div className="w-full aspect-[5/8] bg-slate-900 animate-pulse" />;
}

export default function WebtoonExportTab({ book }) {
  const [outs, setOuts] = useState([]);
  const [pages, setPages] = useState(null);
  const load = useCallback(() => api.get(`/books/${book.id}/comic/outputs?edition=webtoon`).then((r) => setOuts(r.data)), [book.id]);
  useEffect(() => { load(); api.get(`/books/${book.id}/comic/pages`).then((r) => setPages(r.data)); }, [book.id, load]);
  const [job, start, busy] = useJob(load, "Episodes exported");
  const go = async () => { try { const { data } = await api.post(`/books/${book.id}/webtoon/export`); start(data.id); } catch (e) { toast.error(errMsg(e)); } };
  let ep = null;
  return (
    <div className="grid xl:grid-cols-[1fr_380px] gap-6" data-testid="webtoon-export-tab">
      <div className="space-y-4">
        <div className="panel p-5 space-y-3">
          <p className="eyebrow">Episode export</p>
          <p className="text-xs text-slate-400">Download a ZIP with one folder per episode. Every image is 800 px wide and at most 1280 px tall (long panels are sliced), ready for WEBTOON Canvas, Tapas and similar sites. Readers can also scroll it on your showcase.</p>
          <Button onClick={go} disabled={busy || !pages?.length} className="bg-amber-600" data-testid="webtoon-export-build">{busy ? `Exporting… ${job?.progress || 0}%` : "Export episodes"}</Button>
        </div>
        <OutputsList items={outs} testid="webtoon-outputs" />
        <SchedulePanel book={book} />
      </div>
      <div className="panel p-3" data-testid="webtoon-phone-preview">
        <p className="eyebrow mb-2 flex items-center gap-1"><Smartphone size={12} />Phone preview</p>
        <div className="mx-auto w-[300px] h-[600px] overflow-y-auto scrollbar-thin rounded-[28px] border-8 border-slate-800 bg-white">
          {(pages || []).map((p) => { const head = p.episode !== ep; ep = p.episode; return <div key={p.id}>{head && <p className="bg-black text-amber-200 text-[11px] text-center py-1">Episode {p.episode || 1}</p>}<Strip p={p} /></div>; })}
        </div>
      </div>
    </div>
  );
}
